import { createContext, useContext } from 'react';

export const MyRegistrationContext = createContext();

export function useMyRegistration() {
  return useContext(MyRegistrationContext);
}